import React, { Fragment, useContext, useEffect, useState } from "react";
import { Alert, Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import { MaskedInput, createDefaultMaskGenerator } from "react-hook-mask";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import NotyfContext from "../../contexts/NotyfContext";
import $ from "jquery"
import {
  autoScLogin,
  completeEnrollment,
  createMoreUserInfo,
  createUser,
  creditCardDetail,
  fetchQuestions,
  submitQuestionAnswer,
  validateCreditCard,
  verifyAnswers,
  importIDIQReport,
  blankCreateUser,
  markGHLContactDisputely,
} from "../../redux/slices/IdiqApiSlice";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import userData from "./users.json";
import randomCompanies from "./randomCompanies.json";
import moment from "moment";
import Loader from "../../components/Loader";
import InfoPopover from "../../components/new/InfoPopover";
import EnrollmentFailedBot from "./enrollment-failed-bot.png"
import IDIQ from '../../assets/img/providers/idiq-logo.png';
import TrulyID from '../../assets/img/providers/truly-id-logo.png';
import SmartCredit from '../../assets/img/providers/smart-credit-logo.png';
import { Check } from 'react-feather';
import { blankGetAllReportData } from "../../redux/slices/ReportSlice";

const SmartCreditApi = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const notyf = useContext(NotyfContext);

  const create_user = useSelector((state) => state.idiqApi.create_user);
  const create_more_user_info = useSelector(
    (state) => state.idiqApi.create_more_user_info
  );
  const questions = useSelector((state) => state.idiqApi.questions);
  const verifyAnswer = useSelector((state) => state.idiqApi.verifyAnswer);
  const validateCard = useSelector((state) => state.idiqApi.validateCard);
  const setCardDetail = useSelector((state) => state.idiqApi.setCardDetail);
  const completeEnrollmentData = useSelector(
    (state) => state.idiqApi.completeEnrollmentData
  );
  const autoScLoginRes = useSelector((state) => state.idiqApi.autoScLoginRes);

  const userCurrentInfo = useSelector(
    (state) => state.uploadDocument.uploadDocumentData
  );
  const uploadDocumentStatus = useSelector(
    (state) => state.uploadDocument.status
  );

  const [currentStep, setCurrentStep] = useState(1);
  const [questionList, setQuestionList] = useState({});
  const [autoScData, setAutoScData] = useState({});
  const [spinners, setSpinners] = useState(false);

  const maskGenerator = createDefaultMaskGenerator("9999 9999 9999 9999");
  const maskGeneratorExpiry = createDefaultMaskGenerator("99/9999");
  const maskGeneratorCVV = createDefaultMaskGenerator("999");
  const maskGeneratorSSN = createDefaultMaskGenerator("999999999");
  const zipCodeMask = createDefaultMaskGenerator("99999");

  const [errors, setErrors] = useState({
    type: "danger",
    message: null,
  });

  const steps = [
    { id: 0, title: "Create Dispute.Ly Account" },
    { id: 1, title: "Submit Personal Information" },
    { id: 2, title: "Verify your identity" },
  ];

  const getButtonContent = (stepId, activeStep) => {
    if (stepId < activeStep) {
      return <Check width={15} height={24} strokeWidth={3} />;
    }
    return stepId;
  };

  const showPopMessages = (type) => {
    switch (type) {
      case "ENROLLMENT":
        $.confirm({
          title: `Thank you for your interest in using Dispute.Ly`,
          columnClass: "m",
          content: `
          <div>
            <div class="col-12">
              <h4> Hi ${formikCreateUser.values.firstname},</h4>
              <p>
                We apologize for the inconvenience, but we were unable to retrieve your full credit report data from Equifax, Experian, and TransUnion. 
                This may be due to a number of factors, such as a typo in your information or a temporary outage at one of the credit reporting agencies.
              </p>
              <h6>Luckily Dispute.Ly still has an option for you!</h6>
              <p>
                If you have an account or wish to create an account with any of the following credit monitoring sites, 
                you can still take advantage of all the awesome FREE features Dispute.Ly has to offer!
              </p>
            </div>
            
            <div class="text-center col-12">
              <div> <img class="img-fluid" src="${IDIQ}" /> </div>
              <div> <img class="img-fluid" src="${SmartCredit}" /> </div>
            </div>
          </div>
          `,
          type: 'red',
          buttons: {
            "Review Details & Try Again": function(){},
            login: {
              text: "Use Dispute.Ly with a Credit Monitoring Site",
              btnClass: "btn btn-lg btn-outline-primary",
              action: () => navigate("/choose-report")
            }
          },
        });
        break;

      case "NO_NEGATIVE":
        $.confirm({
          title: `Thank you for your interest in using Dispute.Ly`,
          content: `<p>We're sorry to inform you that you do not currently qualify for our offer. This is because we require all of our customers to have at least one negative account on their credit report.<p>
          <p>
          If you feel that this is a mistake, or are interested in disputing other aspects of your credit reports such as personal information and/or inquiries please contact us info@dispute.ly or click the button below
          </p>
          `,
          type: 'blue',
          buttons: {
            close: function(){},
            contact: {
              text: 'CONTACT DISPUTE.LY',
              btnClass: 'btn btn-outline-primary',
              action: function () {
                dispatch(markGHLContactDisputely())
                $.alert("Dispute.ly team has been notified about your interest in exploring additional services. We will be in contact with you shortly")
              },
            },
          },
        });
        break;
    
      case "REPORT_PULL_FAILED":
        $.confirm({
          title: `Failure to Obtain Reports Error `,
          content: `
          <div class="row overflow-hidden">
            <div class="col-md-8">
              <p>We apologize for the inconvenience, but it seems that we have encountered an error while obtaining your Credit Report Information.<p>
              <p>Our team has been notified and we will be in contact with you ASAP about your Dispute.Ly enrollment.</p>
            </div>
            <div class="text-center col-md-4">
              <img class="img-fluid" src="${EnrollmentFailedBot}" />
            </div>
          </div>
          `,
          type: 'red',
          buttons: {
            okay: function(){},
          },
        });
        break;
      default:
        break;
    }
  }

  const fetchUserReport = async () => {
    try {
      const reportResponse = await dispatch(
        importIDIQReport()
      ).unwrap();

      notyf.open({
        type: "success",
        message: "Report Successfully Created and Imported. Redirecting...",
        duration: "3000",
        ripple: false,
        dismissible: false,
        position: {
          x: "right",
          y: "top",
        },
      });

      setTimeout(() => {
        navigate("/report-audit", { replace: true });
      }, 1000);
    } catch (error) {
      showPopMessages("REPORT_PULL_FAILED")
    }
  }

  useEffect(() => {
    dispatch(blankGetAllReportData());
  }, []);

  useEffect(() => {
    let message = "";
    let type = "";
    // //console.log("create_user=>",create_user);
    // //console.log('create user', create_user['error']);
    if (create_user && Object.keys(create_user).length > 0) {
      if (create_user["error"] === 1) {
        type = "danger";
        if (create_user?.data?.errors) {
          message = create_user.data.errors.join(" and ");
        } else {
          message = create_user.msg;
        }

        if(message?.toLocaleLowerCase().includes("no negative accounts")){
          showPopMessages("NO_NEGATIVE")
        }else if(message?.toLowerCase().includes("already a member") || message?.toLowerCase().includes("a hard time locating your file") || message?.toLowerCase().includes("please log in")){
          showPopMessages("ENROLLMENT")
        }

        setErrors({ message, type });
      } else {
        message = "User Created Successfully.";
        type = "success";
        setErrors({ message: "", type });
        let obj = {};
        dispatch(fetchQuestions(obj));
        setCurrentStep(2);
      }
    }
    if (message !== "") {
      notyf.open({
        type: type,
        message: message,
        duration: "3000",
        ripple: false,
        dismissible: false,
        position: {
          x: "right",
          y: "top",
        },
      });
      dispatch(blankCreateUser());
    }

    setSpinners(false);
  }, [create_user]);

  useEffect(() => {
    let message = "";
    let type = "";
    if (
      create_more_user_info &&
      Object.keys(create_more_user_info).length > 0
    ) {
      if (create_more_user_info.status === "success") {
        let data = create_more_user_info.msg;
        message = data;
        type = "success";

        dispatch(fetchQuestions());
        setCurrentStep(3);
      } else {
        type = "danger";
        message = create_more_user_info.msg;
      }
    }
    if (message !== "") {
      notyf.open({
        type: type,
        message: message,
        duration: "3000",
        ripple: false,
        dismissible: false,
        position: {
          x: "right",
          y: "top",
        },
      });
    }
    setSpinners(false);
  }, [create_more_user_info]);

  useEffect(() => {
    // //console.log(questions);
    if (questions && Object.keys(questions).length > 0) {
      const message = questions.data?.message || questions.message;
      if (questions.error === 0) {
        if(message?.toLocaleLowerCase()?.includes("questions retrieved")) showPopMessages("ENROLLMENT");
        else if (questions.data.isSuccess) setQuestionList(questions.data.questions);
        else {
          notyf.open({
            type: "danger",
            message: questions.data?.message || questions.message,
            duration: "3000",
            ripple: false,
            dismissible: false,
            position: {
              x: "right",
              y: "top",
            },
          });
        }
      }
    }
  }, [questions]);

  useEffect(() => {
    let message = "";
    let type = "";
    if (verifyAnswer && Object.keys(verifyAnswer).length > 0) {
      if (verifyAnswer.error === 0) {
        (async () => {
          await fetchUserReport()
        })();

        // let data = verifyAnswer.msg;
        // message = data;
        // type = 'success';
        // dispatch(fetchQuestions())
        // setCurrentStep(4);
      } else {
        type = "danger";
        message = verifyAnswer?.data?.message || verifyAnswer.msg;
        notyf.open({
          type: type,
          message: message,
          duration: "3000",
          ripple: false,
          dismissible: false,
          position: {
            x: "right",
            y: "top",
          },
        });

        if (
          ["morequestions", "incorrect", "accountcodemissing"].includes(
            verifyAnswer?.data?.status?.toLowerCase()
          ) 
        ) {
          let obj = {};
          dispatch(fetchQuestions(obj));
        }

        setSpinners(false);
      }
    }
  }, [verifyAnswer]);

  useEffect(() => {
    let message = "";
    let type = "";
    if (validateCard && Object.keys(validateCard).length > 0) {
      if (validateCard.status === "success") {
        let data = validateCard.msg;
        let obj = {
          card_token: data,
          name: formikCreditCard.values.card_name,
          cvv: formikCreditCard.values.cvv,
          month: formikCreditCard.values.expiry.slice(0, 2),
          year: formikCreditCard.values.expiry.slice(2),
        };
        dispatch(creditCardDetail(obj));
      } else {
        setSpinners(false);
        type = "danger";
        message = validateCard.msg;
      }
    }
    if (message !== "") {
      notyf.open({
        type: type,
        message: message,
        duration: "3000",
        ripple: false,
        dismissible: false,
        position: {
          x: "right",
          y: "top",
        },
      });
    }
    setSpinners(false);
  }, [validateCard]);

  useEffect(() => {
    let message = "";
    let type = "";
    if (setCardDetail && Object.keys(setCardDetail).length > 0) {
      if (setCardDetail.status === "success") {
        dispatch(completeEnrollment());
      } else {
        setSpinners(false);
        type = "danger";
        message = setCardDetail.msg;
      }
    }
    if (message !== "") {
      notyf.open({
        type: type,
        message: message,
        duration: "3000",
        ripple: false,
        dismissible: false,
        position: {
          x: "right",
          y: "top",
        },
      });
    }
  }, [setCardDetail]);

  useEffect(() => {
    let message = "";
    let type = "";
    if (
      completeEnrollmentData &&
      Object.keys(completeEnrollmentData).length > 0
    ) {
      if (completeEnrollmentData.status === "success") {
        type = "success";
        message = "Your account created successfully.";

        setCurrentStep(5);
      } else {
        setSpinners(false);
        type = "danger";
        message = completeEnrollmentData.msg;
      }
    }
    if (message !== "") {
      notyf.open({
        type: type,
        message: message,
        duration: "3000",
        ripple: false,
        dismissible: false,
        position: {
          x: "right",
          y: "top",
        },
      });
    }
    setSpinners(false);
  }, [completeEnrollmentData]);

  useEffect(() => {
    let message = "";
    let type = "";
    if (autoScLoginRes && Object.keys(autoScLoginRes).length > 0) {
      if (autoScLoginRes.status === "success") {
        let data = autoScLoginRes.msg;
        if (data == null) {
          let obj = {
            username: formikCreateUser.values.email,
            password: formikCreateUser.values.password,
          };
          dispatch(autoScLogin(obj));
        } else {
          setCurrentStep(6);
          setAutoScData(data);
        }
      } else {
        // type = "danger";
        // message = autoScLoginRes.msg;
        let obj = {
          username: formikCreateUser.values.email,
          password: formikCreateUser.values.password,
        };
        dispatch(autoScLogin(obj));
      }
    }
    if (message !== "") {
      notyf.open({
        type: type,
        message: message,
        duration: "3000",
        ripple: false,
        dismissible: false,
        position: {
          x: "right",
          y: "top",
        },
      });
    }
    setSpinners(false);
  }, [autoScLoginRes]);

  const getJsonData = () => {
    setSpinners(true);
    let obj = {
      username: formikCreateUser.values.email,
      password: formikCreateUser.values.password,
    };
    dispatch(autoScLogin(obj));
  };

  const randomizeEmail = () => {
    const randomUser = formikCreateUser.values;
    const randomCompany =
      randomCompanies[Math.floor(Math.random() * randomCompanies.length)];
    const randomNumber = Math.floor(Math.random() * 10000);
    const formats = [
      `${randomUser.firstname[0]}${randomUser.lastname}`,
      `${randomUser.firstname}.${randomUser.lastname}`,
      `${randomUser.firstname}${randomUser.lastname}`,
      `${randomUser.lastname}${randomUser.firstname}`,
      `${randomUser.firstname}${randomNumber}`,
      Math.random().toString(36).substring(2, 10),
    ];
    const randomFormat = formats[Math.floor(Math.random() * formats.length)];

    // Filter out any characters that are not letters or numbers
    const filteredFormat = randomFormat.replace(/[^a-zA-Z0-9]/g, "");

    formikCreateUser.setFieldValue(
      "email",
      `${filteredFormat}@${randomCompany}.com`
    );
  };

  const formatDate = (dateString) => {
    const [month, day, year] = dateString.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };

  const formikCreateUser = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstname: "",
      lastname: "",
      city: "",
      state: "",
      zip: "",
      dob: "",
      ssn: "",
      street: "",
      agreement: false,
    },

    // initialValues: {
    //   firstname: 'HOT',
    //   lastname: 'CHILI',
    //   email: 'example66@example.com',
    //   city: 'CASTLE HAYNE',
    //   state: 'NC',
    //   zip: '28430',
    //   dob: '01/01/1984',
    //   ssn: '666-52-5461',
    //   street: '3325 ARMORY RD',
    // },

    validationSchema: Yup.object().shape({
      firstname: Yup.string().max(255).required("First Name is required"),
      lastname: Yup.string().max(255).required("Last Name is required"),
      city: Yup.string().max(255).required("City is required"),
      state: Yup.string().max(255).required("State is required"),
      zip: Yup.string().max(255).required("Zip is required"),
      ssn: Yup.string().max(255).required("Social Security Number is required"),
      dob: Yup.date().required("Date Of Birth is required"),
      street: Yup.string().max(255).required("Street is required"),
      agreement: Yup.boolean().required("Agreemnet is required"),
    }),
    onSubmit: async (values) => {
      setSpinners(true);
      let obj = {
        first_name: values.firstname,
        last_name: values.lastname,
        ssn: values.ssn,
        dob: moment(values.dob, "YYYY-MM-DD").format("MM/DD/YYYY"),
        street: values.street,
        city: values.city,
        state: values.state,
        zip: values.zip,
      };
      dispatch(createUser(obj));
    },
  });

  useEffect(() => {
    uploadDocumentStatus === "succeeded" &&
      formikCreateUser.setValues({
        firstname: userCurrentInfo?.response?.client_fname || "",
        lastname: userCurrentInfo?.response?.client_lname || "",
        city: userCurrentInfo?.response?.country || "",
        state: userCurrentInfo?.response?.state || "",
        zip: userCurrentInfo?.response?.zip || "",
        dob: userCurrentInfo?.response?.dob || "",
        street: userCurrentInfo?.response?.address1 || "",
      });
  }, [uploadDocumentStatus]);

  const randomizeData = () => {
    //console.log(userData);
    const randomUser = userData[Math.floor(Math.random() * userData.length)];
    //console.log(randomUser);
    //console.log(formikCreateUser);
    formikCreateUser.setValues({
      firstname: randomUser["First Name"],
      lastname: randomUser["Last Name"],
      city: randomUser.City,
      state: randomUser.State,
      zip: randomUser.PostalCode,
      dob: formatDate(randomUser.DOB),
      ssn: randomUser.SSN,
      street: randomUser["Street Name"],
    });
    // //console.log('formikCreateUser:', formikCreateUser);
    // //console.log('dob:', formikCreateUser.DOB);
    // //console.log('formikCreateUser values:', formikCreateUser.values);
    // //console.log('formikCreateUser DOB:', formikCreateUser.values.dob);
    // //console.log('randomUser:', randomUser);
    // //console.log('randomUser DOB:', randomUser.DOB);
  };
  // //console.log('formikCreateUser.values.dob', formikCreateUser.values.dob);
  // //console.log('formikCreateUser dob:', formikCreateUser.DOB);

  const handleQuestionAnswerSubmit = async (e) => {
    e.preventDefault();
    formikQuestionAnswer.handleSubmit(e);
    formikQuestionAnswer.setSubmitting(true);
    setSpinners(true);
    const selectedAnswerIds = [...formikQuestionAnswer.values.answers];
    // //console.log('selectedAnswerIds:', selectedAnswerIds);

    try {
      await dispatch(
        verifyAnswers({
          selectedAnswerIds: selectedAnswerIds,
        })
      ).unwrap();
      // Handle successful verification
      // //console.log('verifyAnswers result:', result);
      // TODO: Handle the result as needed, e.g., show a success message
    } catch (error) {
      notyf.open({
        type: "danger",
        message: error.message,
        duration: "3000",
        ripple: false,
        dismissible: false,
        position: {
          x: "right",
          y: "top",
        },
      });
      setSpinners(false);
      formikQuestionAnswer.setSubmitting(false);
      formikQuestionAnswer.setErrors({
        submit: "There was an error submitting security answers",
      });
      // Handle failed verification
      // //console.log('verifyAnswers error:', error.message);
      // TODO: Handle the error as needed, e.g., show an error message
    }
  };

  const randomizeForm = () => {
    randomizeData();
    randomizeEmail();
  };

  // In your JSX

  const formikMoreUserInfo = useFormik({
    enableReinitialize: true,
    initialValues: {
      ssn: "",
      dob: "",
    },
    validationSchema: Yup.object().shape({
      ssn: Yup.string().max(255).required("Social Security Number is required"),
      dob: Yup.date().required("DOB is required"),
    }),
    onSubmit: async (values) => {
      setSpinners(true);
      let obj = {
        phone: values.phone,
        street: values.street,
        zip: values.zip,
        city: values.city,
        state: values.state,
        dob: values.dob,
        ssn: formikCreateUser.values.ssn,
      };
      dispatch(createMoreUserInfo(obj));
    },
  });
  const formikQuestionAnswer = useFormik({
    enableReinitialize: true,
    initialValues: {
      answers: [],
    },
    validationSchema: Yup.object().shape({
      answers: Yup.array().min(1).required("Answers are required"),
    }),
    onSubmit: async (values) => {
      // setSpinners(true);
      // let obj = {
      //   ref_number: questionList.idVerificationCriteria ? questionList.idVerificationCriteria.referenceNumber : null,
      //   q1: values.answer1,
      //   q2: values.answer2,
      //   q3: values.answer3,
      // };
      // dispatch(submitQuestionAnswer(obj));
    },
  });
  const formikCreditCard = useFormik({
    enableReinitialize: true,
    initialValues: {
      credit_card: "",
      card_name: "",
      expiry: "",
      cvv: "",
    },
    validationSchema: Yup.object().shape({
      credit_card: Yup.string().max(255).required("Credit Card is required"),
      card_name: Yup.string().max(255).required("Credit Name is required"),
      expiry: Yup.string().max(255).required("Expiry is required"),
      cvv: Yup.string().max(255).required("CVV is required"),
    }),
    onSubmit: async (values) => {
      setSpinners(true);
      let obj = {
        cc_number: values.credit_card,
      };
      dispatch(validateCreditCard(obj));
      // setCurrentStep(1)
    },
  });

  if (uploadDocumentStatus === "loading") return <Loader />;

  return (
    <Fragment>
      <Helmet title='Security Questions' />
      <style>
        {`
               
                .card {
                  min-width: 600px !important;
                }

                @media (max-width: 600px) {
                  .card {
                  min-width: 405px !important;
                }
                  }

                @media (max-width: 500px) {
                  body {
                overflow: auto !important;
                }
                }
                .bottom-border-only {
                  border: none !important;
                  border-bottom: 1px solid #ced4da !important;
                  border-radius: 0 !important;
                  box-shadow: none !important;
                }

                .bottom-border-only:focus {
                  border-color: #80bdff !important;
                  box-shadow: none !important;
                }

                
                 `}
      </style>
      <div className='security-questions-container'>
        <Row className='justify-content-center'>
          <Col
            xs={12}
            md={12}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <div>
              <div className='steps overflow-x-auto w-100 pb-3'>
                <div
                  id='progress'
                  style={{
                    appearance: '-webkit-appearance',
                    position: 'absolute',
                    zIndex: '5',
                    border: '#c8ccdf dashed',
                    borderWidth: '3px 0px 0px 0px',
                    top: '2.25rem',
                    maxWidth: '70%',
                    left: '90px',
                  }}></div>
                <div
                  id='progress-complete'
                  style={{
                    position: 'absolute',
                    zIndex: '5',
                    border: 'rgb(var(--bs-primary-rgb)) solid',
                    borderWidth: '3px 0px 0px 0px',
                    top: '2.25rem',
                    maxWidth: '70%',
                    width: `${currentStep * 35}%`,
                    left: '90px',
                    transition: 'width 2s cubic-bezier(0.25, 0, 0.5, 1)',
                  }}></div>

                {steps.map((step, index) => {
                  const isActive = step.id === currentStep;
                  const isCompleted = step.id < currentStep;

                  const buttonClassName = isActive ? 'step-button text-primary bg-light border border-2 border-primary text-center fw-bold' : isCompleted ? 'text-white bg-primary border border-2 border-primary text-center fw-bold' : 'step-button text-secondary bg-light border border-2 border-secondary text-center fw-bold';

                  return (
                    <div key={index} style={{ minWidth: '197px' }} className={` step-item  text-center ${isActive ? 'active' : isCompleted ? 'completed' : ''}`}>
                      <button type='button' className={`step-button ${buttonClassName} p-0`} style={step.buttonStyle || {}}>
                        {getButtonContent(step.id, currentStep)}
                      </button>
                      <div
                        className='step-title w-100 mx-auto'
                        style={{
                          fontWeight: '400',
                          textAlign: 'center',
                          marginBottom: '1.5rem',
                          color: isCompleted ? '#000e4e' : '#7c84a5',
                        }}>
                        {step.title}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={4}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <Card className='bg-white shadow-none flex-column border-0 p-3 security-card rounded-4'>
              <Card.Body>
                <h3 className='text-center mb-1'>Get Your Free Credit Report</h3>
                {errors.message && <Alert variant={errors.type}>{errors.message}</Alert>}
                {currentStep === 1 && (
                  <Form onSubmit={formikCreateUser.handleSubmit}>
                    {/* <Button onClick={randomizeForm}>Randomize</Button> */}

                    <Row>
                      <Col xs={12} md={6} className='mb-3'>
                        <Form.Group>
                          <Form.Label className='text-light-gray' size='lg'>
                            First Name
                          </Form.Label>
                          <Form.Control className='bottom-border-only' type='text' id='firstname' name='firstname' placeholder='First Name' size='lg' onChange={formikCreateUser.handleChange} onBlur={formikCreateUser.handleBlur} value={formikCreateUser.values.firstname} isInvalid={Boolean(formikCreateUser.touched.firstname && formikCreateUser.errors.firstname)} />
                          {!!formikCreateUser.touched.firstname && <Form.Control.Feedback type='invalid'>{formikCreateUser.errors.firstname}</Form.Control.Feedback>}
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={6} className='mb-3'>
                        <Form.Group>
                          <Form.Label className='text-light-gray'>Last Name</Form.Label>
                          <Form.Control className='bottom-border-only' type='text' id='lastname' name='lastname' placeholder='Last Name' size='lg' onChange={formikCreateUser.handleChange} onBlur={formikCreateUser.handleBlur} value={formikCreateUser.values.lastname} isInvalid={Boolean(formikCreateUser.touched.lastname && formikCreateUser.errors.lastname)} />
                          {!!formikCreateUser.touched.lastname && <Form.Control.Feedback type='invalid'>{formikCreateUser.errors.lastname}</Form.Control.Feedback>}
                        </Form.Group>
                      </Col>

                      <Col xs='12' className='my-3'>
                        <Form.Group>
                          <Form.Label className='text-light-gray'>Address</Form.Label>
                          <Form.Control className='bottom-border-only' type='text' id='street' name='street' placeholder='Street' size='lg' onChange={formikCreateUser.handleChange} onBlur={formikCreateUser.handleBlur} value={formikCreateUser.values.street} isInvalid={Boolean(formikCreateUser.touched.street && formikCreateUser.errors.street)} />
                          {!!formikCreateUser.touched.street && <Form.Control.Feedback type='invalid'>{formikCreateUser.errors.street}</Form.Control.Feedback>}
                        </Form.Group>
                      </Col>
                      <Col xs={12} lg={6} className='mb-3'>
                        <Form.Group>
                          <Form.Label className='text-light-gray'>City</Form.Label>
                          <Form.Control className='bottom-border-only' type='text' id='city' name='city' placeholder='City' size='lg' onChange={formikCreateUser.handleChange} onBlur={formikCreateUser.handleBlur} value={formikCreateUser.values.city} isInvalid={Boolean(formikCreateUser.touched.city && formikCreateUser.errors.city)} />
                          {!!formikCreateUser.touched.city && <Form.Control.Feedback type='invalid'>{formikCreateUser.errors.city}</Form.Control.Feedback>}
                        </Form.Group>
                      </Col>
                      <Col xs={6} lg={2} className='mb-3'>
                        <Form.Group>
                          <Form.Label className='text-light-gray'>State</Form.Label>
                          <Form.Control className='bottom-border-only' type='text' id='state' name='state' placeholder='State' size='lg' onChange={formikCreateUser.handleChange} onBlur={formikCreateUser.handleBlur} value={formikCreateUser.values.state} isInvalid={Boolean(formikCreateUser.touched.state && formikCreateUser.errors.state)} />
                          {!!formikCreateUser.touched.state && <Form.Control.Feedback type='invalid'>{formikCreateUser.errors.state}</Form.Control.Feedback>}
                        </Form.Group>
                      </Col>
                      <Col xs={6} lg={4} className='mb-3'>
                        <Form.Group>
                          <Form.Label className='text-light-gray'>Zip</Form.Label>
                          <MaskedInput
                            maskGenerator={zipCodeMask}
                            className={`form-control form-control-lg bottom-border-only ${Boolean(formikCreateUser.touched.zip && formikCreateUser.errors.zip) ? 'is-invalid' : ''}`}
                            type='text'
                            name='zip'
                            id='zip'
                            placeholder='XXXXX'
                            size='lg'
                            onChange={e => {
                              formikCreateUser.setFieldValue('zip', e);
                            }}
                            value={formikCreateUser.values.zip}
                            isInvalid={Boolean(formikCreateUser.touched.zip && formikCreateUser.errors.zip)}
                          />
                          {!!formikCreateUser.touched.zip && <Form.Control.Feedback type='invalid'>{formikCreateUser.errors.zip}</Form.Control.Feedback>}
                        </Form.Group>
                      </Col>

                      <Col xs={12} md={6} className='mb-3'>
                        <Form.Group>
                          <Form.Label className='text-light-gray'>
                            Social Security Number{' '}
                            <InfoPopover
                              iconMargin={0}
                              headerContent={'Why do I need to submit my Social Security Number?'}
                              bodyContent={
                                <div>
                                  <p>In order to obtain information from the credit bureaus, a Social Security Number is needed to identify the individual whose credit is to be pulled. The credit bureaus use this information to verify your identity and to ensure that you are the only person who can access your credit report.</p>
                                  <p>We understand that you may be concerned about the security of your personal information, including your Social Security Number. We want to assure you that your information is safe with us. We use the latest security measures to protect your data, and we will only use it to access information from Equifax, Experian, and Transunion.</p>
                                  <p className='mt-3'>Thank you for your understanding.</p>
                                </div>
                              }
                            />
                          </Form.Label>
                          <MaskedInput
                            maskGenerator={maskGeneratorSSN}
                            className={`form-control form-control-lg bottom-border-only ${Boolean(formikCreateUser.touched.ssn && formikCreateUser.errors.ssn) ? 'is-invalid' : ''}`}
                            type='text'
                            name='ssn'
                            id='ssn'
                            placeholder='XXXXXXXXX'
                            size='lg'
                            onChange={e => {
                              formikCreateUser.setFieldValue('ssn', e);
                            }}
                            value={formikCreateUser.values.ssn}
                            isInvalid={Boolean(formikCreateUser.touched.ssn && formikCreateUser.errors.ssn)}
                          />
                          {!!formikCreateUser.touched.ssn && <Form.Control.Feedback type='invalid'>{formikCreateUser.errors.ssn}</Form.Control.Feedback>}
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={6} className='mb-3'>
                        <Form.Group>
                          <Form.Label className='text-light-gray'>Date Of Birth</Form.Label>
                          <Form.Control
                            className='bottom-border-only'
                            type='date' // Change type to 'date'
                            id='dob'
                            name='dob'
                            placeholder='Date of Birth'
                            size='lg'
                            onChange={formikCreateUser.handleChange}
                            onBlur={formikCreateUser.handleBlur}
                            value={formikCreateUser.values.dob}
                            isInvalid={Boolean(formikCreateUser.touched.dob && formikCreateUser.errors.dob)}
                          />
                          {!!formikCreateUser.touched.dob && <Form.Control.Feedback type='invalid'>{formikCreateUser.errors.dob}</Form.Control.Feedback>}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col xs={12}>
                        <Form.Group>
                          <Form.Check
                            type='checkbox'
                            id='custom-checkbox'
                            label='By clicking "Opt In" I agree by electronic signature to: (1) Opt in to SMS Campaigns that are used for marketing purposes only. Our intention for our SMS Marketing Campaigns is to follow up with you on your request for our services. If you would like to opt out of the Campaign at any time, please respond to any SMS messages with "STOP" and you will be immediately removed from our Campaign (2) the Privacy Policy and Terms of Use (including this arbitration provision). '
                            onChange={formikCreateUser.handleChange}
                            onBlur={formikCreateUser.handleBlur}
                            value={formikCreateUser.values.agreement}
                            name="agreement"
                            isInvalid={Boolean(formikCreateUser.touched.agreement && formikCreateUser.errors.agreement)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Button type='submit' variant='primary' size='lg' className='w-100 mt-4'>
                      Submit & Continue {spinners && <Spinner animation='border' size='sm' />}
                    </Button>
                  </Form>
                )}
                {currentStep === 2 && (
                  <Form onSubmit={handleQuestionAnswerSubmit}>
                    <div className='text-center'>
                      <h4 className='mb-3'>Let's get your reports!</h4>
                      <p>In order to get all three credit reports from Equifax , Experian, and Transunion we have to confirm your identity and ask you some security questions</p>
                    </div>

                    {questionList?.length > 0 ? (
                      <>
                        <Row className='mb-3'>
                          {questionList.map((data, index) => {
                            if (formikQuestionAnswer.values.answers.length !== questionList.length) {
                              formikQuestionAnswer.setFieldValue('answers', [...questionList.map(i => '')]);
                            }
                            return (
                              <Fragment>
                                <Col xs='12'>
                                  <Form.Group>
                                    {/* <Form.Label className='text-light-gray mb-0'>Question {index + 1}</Form.Label> */}
                                    <Form.Label className='form-control-plaintext' id={`question${index + 1}`} readOnly>
                                      {data.text}
                                    </Form.Label>{' '}
                                  </Form.Group>
                                </Col>
                                <Col xs='12' className='mb-4'>
                                  <Form.Group>
                                    {/* <Form.Label className='text-light-gray'>Answer {index + 1}</Form.Label> */}
                                    {data.answers.map((dataIn, indexIn) => {
                                      return (
                                        <Form.Check
                                          type='radio'
                                          onChange={formikQuestionAnswer.handleChange}
                                          id={`answer${index + 1}-${indexIn}`}
                                          key={indexIn}
                                          name={`answers[${index}]`}
                                          label={dataIn.text}
                                          required
                                          {...{
                                            ...formikQuestionAnswer.getFieldProps(`answers[${index}]`),
                                            value: dataIn.id,
                                          }}
                                        />
                                      );
                                    })}
                                    {formikQuestionAnswer.touched[`answers`] && formikQuestionAnswer.errors[`answers`] ? <Form.Control.Feedback type='invalid'>{formikQuestionAnswer.errors[`answers`]}</Form.Control.Feedback> : null}
                                  </Form.Group>
                                </Col>
                              </Fragment>
                            );
                          })}
                        </Row>
                        <Row>
                          <Col>
                            <Button type='submit' disabled={formikQuestionAnswer.isSubmitting || spinners} variant='primary' size='lg' className='w-100'>
                              {spinners ? (
                                <>
                                  <Spinner animation='border' size='sm' /> {'Give us a few seconds while we retrieve your credit report data'}
                                </>
                              ) : (
                                'Submit'
                              )}
                            </Button>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      <>
                        <div className='d-flex flex-column justify-content-center align-items-center'>
                          <Spinner animation='border' size='lg' />
                          <p>Getting security questions...</p>
                        </div>
                      </>
                    )}
                  </Form>
                )}
                {currentStep === 3 && (
                  <Form className='mb-4' onSubmit={formikCreditCard.handleSubmit}>
                    <Row>
                      <Col xs='6' className='mb-3'>
                        <Form.Group>
                          <Form.Label className='text-light-gray'>Card Name</Form.Label>
                          <Form.Control type='text' name='card_name' id='card_name' placeholder='Card Name' size='lg' onChange={formikCreditCard.handleChange} onBlur={formikCreditCard.handleBlur} value={formikCreditCard.values.card_name} isInvalid={Boolean(formikCreditCard.touched.card_name && formikCreditCard.errors.card_name)} />
                          {!!formikCreditCard.touched.card_name && <Form.Control.Feedback type='invalid'>{formikCreditCard.errors.card_name}</Form.Control.Feedback>}
                        </Form.Group>
                      </Col>
                      <Col xs='6' className='mb-3'>
                        <Form.Group className='mb-3'>
                          <Form.Label className='text-light-gray'>Credit Card</Form.Label>
                          <MaskedInput
                            maskGenerator={maskGenerator}
                            className={`form-control form-control-lg ${Boolean(formikCreditCard.touched.credit_card && formikCreditCard.errors.credit_card) ? 'is-invalid' : ''}`}
                            type='text'
                            name='credit_card'
                            id='credit_card'
                            placeholder='XXXX XXXXX XXXX XXXX'
                            size='lg'
                            onChange={e => {
                              formikCreditCard.setFieldValue('credit_card', e);
                            }}
                            value={formikCreditCard.values.credit_card}
                            isInvalid={Boolean(formikCreditCard.touched.credit_card && formikCreditCard.errors.credit_card)}
                          />
                          {!!formikCreditCard.touched.credit_card && <Form.Control.Feedback type='invalid'>{formikCreditCard.errors.credit_card}</Form.Control.Feedback>}
                        </Form.Group>
                      </Col>
                      <Col xs='6' className='mb-3'>
                        <Form.Group>
                          <Form.Label className='text-light-gray form-label' htmlFor='expiry'>
                            Expiration
                          </Form.Label>
                          <MaskedInput
                            maskGenerator={maskGeneratorExpiry}
                            type='text'
                            id='expiry'
                            name='expiry'
                            className={`form-control form-control-lg ${Boolean(formikCreditCard.touched.expiry && formikCreditCard.errors.expiry) ? 'is-invalid' : ''}`}
                            placeholder='MM/YYYY'
                            size='lg'
                            onChange={e => {
                              formikCreditCard.setFieldValue('expiry', e);
                            }}
                            value={formikCreditCard.values.expiry}
                            isInvalid={Boolean(formikCreditCard.touched.expiry && formikCreditCard.errors.expiry)}
                          />
                          {!!formikCreditCard.touched.expiry && <Form.Control.Feedback type='invalid'>{formikCreditCard.errors.expiry}</Form.Control.Feedback>}
                        </Form.Group>
                      </Col>
                      <Col xs='6' className='mb-3'>
                        <Form.Group>
                          <Form.Label className='text-light-gray form-label' htmlFor='cvv'>
                            CVV
                          </Form.Label>
                          <MaskedInput
                            maskGenerator={maskGeneratorCVV}
                            type='password'
                            id='cvv'
                            name='cvv'
                            className={`form-control form-control-lg ${Boolean(formikCreditCard.touched.cvv && formikCreditCard.errors.cvv) ? 'is-invalid' : ''}`}
                            placeholder='***'
                            size='lg'
                            onChange={e => {
                              formikCreditCard.setFieldValue('cvv', e);
                            }}
                            value={formikCreditCard.values.cvv}
                            isInvalid={Boolean(formikCreditCard.touched.cvv && formikCreditCard.errors.cvv)}
                          />
                          {!!formikCreditCard.touched.cvv && <Form.Control.Feedback type='invalid'>{formikCreditCard.errors.cvv}</Form.Control.Feedback>}
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <Button type='submit' variant='primary' size='lg' className='w-100 mt-4'>
                          Submit {spinners && <Spinner animation='border' size='sm' />}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
                {currentStep === 4 && (
                  <>
                    <div>
                      <h3>Thanks</h3>
                      <h5>Enrollment process done successfully</h5>
                      <br />
                      <br />
                      <Button type='button' variant='primary' size='lg' className='w-100' onClick={() => getJsonData()}>
                        Access Credit Report {spinners && <Spinner animation='border' size='sm' />}
                      </Button>
                    </div>
                  </>
                )}
                {currentStep === 5 && (
                  <Form className='mb-4'>
                    <Form.Group>
                      <Form.Label>Json Data</Form.Label>
                      <Form.Control as='textarea' rows={3} id='json_data' name='json_data' value={Object.keys(autoScData).length > 0 ? autoScData : ''} readOnly />
                    </Form.Group>
                  </Form>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </Fragment>
  );
};

export default SmartCreditApi;
